import { createSlice } from '@reduxjs/toolkit';
import Goal from "src/models/Goal";
import { Contribution } from 'src/models/Contribution';
import { getGoals, updateDailies } from 'src/thunks/goalThunks';






interface GoalsState {
  goals: Goal[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  debugStatus: string | null;
}

const initialState: GoalsState = {
  goals: [] as Goal[],
  status: 'idle',
  error: null,
  debugStatus: 'um?'
};

const dailiesSlice = createSlice({
  name: 'dailies',
  initialState,
  reducers: {
    debugAction(state, action) {
      state.debugStatus = action.payload["status"];
    },
    createGoal(state, action) {
      const newGoal = action.payload;

      state.goals.push(newGoal);
    },
    updateGoal: (state, action) => {
      // const updatedGoal = Goal.createFromObject(action.payload);
      // const index = state.goals.findIndex((goal) => goal.id === updatedGoal.id);

      // if (index !== -1) {
      //   // Use object spread to update the goal
      //   state.goals[index] = Goal.createFromObject({ ...state.goals[index], ...updatedGoal }) ;
      //   state.goals[index].userContributions = updatedGoal.userContributions;
      // }
    },
    removeGoal: (state, action) => {
      // const goalToRemove = action.payload as Goal;
      // state.goals.forEach((goal) => {
      //   goal.tasks = goal.tasks.filter((task) => task !== goalToRemove);
      // });
      // // Find and remove the task from the state
      // state.goals.forEach((goal) => {
      //   goal.tasks = goal.tasks.filter((task) => task !== taskToRemove);
      // });
      // console.log("TRUETOGGLE");
      // console.log(action);
      // const today = new Date();
      // const goal = state.goals.find((goal) => goal.id === action.payload.id);
      // if (goal) {

      // const updatedGoal = {
      //   ...goal,
      //   userContributions: [ ...goal.userContributions, new Contribution("lione",  5, today)],
      // };
      // state.goals = state.goals.map((g) =>
      //     g.id === action.payload.id ? updatedGoal : g
      //   );
      //   console.log(updatedGoal);
      //   console.log("umm");
    },
    removeUserContributions: (state, action) => {
      const contributionsToRemove = action.payload.contributionsToRemove as Contribution[];
      const goalId = action.payload.goalId;
      const goalIndex = state.goals.findIndex((goal) => goal.id === goalId);
      contributionsToRemove.forEach(contributionToRemove => {
        state.goals[goalIndex].userContributions = state.goals[goalIndex].userContributions.filter(contr => {
          return !Contribution.compare(contr, contributionToRemove);
        });
      });
    },
    addUserContributions: (state, action) => {
      const contributionsToAdd = action.payload.contributionsToAdd as Contribution[];
      const goalId = action.payload.goalId;
      const goalIndex = state.goals.findIndex((goal) => goal.id === goalId);
      console.log("add?");
      console.log(contributionsToAdd);
      contributionsToAdd.forEach(contr => {
        state.goals[goalIndex].userContributions.push(contr);
      });
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getGoals.pending, (state) => {
        state.status = 'loading';
        console.log("loadingggg");
      })
      .addCase(getGoals.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.goals = action.payload;
        console.log("fulfilled");
      })
      .addCase(getGoals.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || "Error fetching goals";
        console.log("failedddd");
      }).addCase(updateDailies.pending, (state) => {
        state.status = 'loading';
        console.log("loadingasfasdggg");
      })
      .addCase(updateDailies.fulfilled, (state, action) => {
        state.status = 'succeeded';
        console.log("fulfilled");
      })


  },
});


export const { createGoal, updateGoal, removeGoal, removeUserContributions, addUserContributions, debugAction } = dailiesSlice.actions;

export default dailiesSlice.reducer;